import { FC } from 'react';
import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import styles from './index.module.scss';
import Card from './Card/Card';

export type StatsCardProps = SliceComponentProps<Content.StatsCardSlice>;

const StatsCard: FC<StatsCardProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        <PrismicRichText field={slice.primary.title} />
      </div>
      <ul className={styles.cards}>
        {slice.primary.cards.map((card) => (
          <Card key={card.title} data={card} />
        ))}
      </ul>
    </section>
  );
};

export default StatsCard;
